import type { DomainTaskStatusType } from "@porchpass/api-client";

export const CONDITION_STATUSES: DomainTaskStatusType[] = [
  "not_done",
  "in_progress",
  "in_review",
  "done",
  "cancelled",
  "correction_needed",
];
